import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TableBody,
  Box as MuiBox,
  LinearProgress,
} from "@mui/material";
import { Box } from "@mui/system";
import "./AdditionalPageGroupContent.css";
import { Alert } from "@mui/material";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Link, useSearchParams } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
interface additionalPageGroupContentProps {
  additionalContent: any;
}

function AdditionalPageGroupContent({
  additionalContent,
}: additionalPageGroupContentProps) {
  const [searchParams] = useSearchParams();
  const selectedSite = searchParams.get("selectedSite");
  const themes = additionalContent.themes.map((theme: any, index: number) => {
    const firstProportion = additionalContent.theme_v1_proportions;

    return {
      Version: theme.version,
      name: theme.name || "", // Fallback for null names
      proportion:
        index === 0
          ? firstProportion // First theme uses the provided proportion
          : firstProportion === 100
          ? 0 // If first proportion is 100, second is 0
          : 100 - firstProportion, // Otherwise, calculate as 100 - first proportion
    };
  });

  const popups = additionalContent.popups.map((popup: any, index: any) => {
    const firstProportion = additionalContent.popup_v1_proportions;

    return {
      Version: popup?.version,
      name: popup?.name,
      DesktopContent: popup?.desktop_content,
      MobileContent: popup?.mobile_content,
      Appearance: popup?.appearance || 0,
      Proportion:
        index === 0
          ? firstProportion // First theme uses the provided proportion
          : firstProportion === 100
          ? 0 // If first proportion is 100, second is 0
          : 100 - firstProportion, // Otherwise, calculate as 100 - first proportion
    };
  });

  const comparisonTables = additionalContent.comparison_tables.map(
    (table: any, index: any) => {
      return {
        number: index + 1,
        tablename: table?.table,
        status: table?.active,
      };
    }
  );

  const trafficSources = additionalContent.traffic_sources.map(
    (source: any, index: any) => {
      return {
        number: index + 1,
        sourcename: source?.source,
        status: source?.active,
      };
    }
  );

  const devices = ["Desktop", "Tablet", "Mobile"];

  const transformedData = devices.map((device) => ({
    device,
    secondheadline: additionalContent.headlines[device.toLowerCase()] || "", // Default if null
    bannerimage: additionalContent.banners[device.toLowerCase()] || "", // Default if null
  }));
  const CustomProgressBar = ({
    value,
    color = "#9c27b0",
  }: {
    value: number;
    color?: string;
  }) => (
    <MuiBox sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <MuiBox sx={{ width: "100%", mr: 1 }}>
        <LinearProgress
          variant="determinate"
          value={value}
          sx={{
            height: 5,
            backgroundColor: "#f0f0f0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: color,
            },
          }}
        />
      </MuiBox>
      <MuiBox sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: "12px" }}
        >
          {`${value}%`}
        </Typography>
      </MuiBox>
    </MuiBox>
  );
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={4} marginBottom={4}>
          <Grid item xs={3} md={3}>
            <Box marginBottom={4}>
              <Typography>Theme</Typography>
              <TableContainer className="pagegroupwrap">
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" sx={{ margin: "16px" }}>
                        Vr
                      </TableCell>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="left">Proportion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {themes?.map((themerow: any) => (
                      <TableRow
                        key={themerow.Version}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {themerow.Version}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <span>{themerow.name}</span>
                          <Link
                            data-tracker="373"
                            to={`/assets/design/theme?selectedSite=${selectedSite}&search=${encodeURIComponent(
                              themerow.name
                            ).replace(/%20/g, "+")}`}
                            target="_blank"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {themerow.name?.trim() && (
                              <OpenInNewIcon
                                sx={{
                                  fontSize: 16,
                                  color: "#9c27b0",
                                }}
                              />
                            )}
                          </Link>
                        </TableCell>
                        <TableCell align="left">
                          {themerow.proportion}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid item xs={6} md={6}>
            <Box>
              <Typography>Popup</Typography>
              <TableContainer className="pagegroupwrap">
                <Table
                  aria-label="simple table"
                  // sx={{
                  //   borderCollapse: "separate",
                  //   borderSpacing: "12px 0", // 12px horizontal, 0px vertical spacing
                  // }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Vr</TableCell>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="left">Proportion</TableCell>
                      <TableCell align="left">Appearance</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {popups.map((popuprow: any) => (
                      <TableRow
                        key={popuprow.Version}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {popuprow.Version}
                        </TableCell>
                        <TableCell align="left">
                          <MuiBox>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "medium", mb: 0.5 }}
                            >
                              {popuprow.name}
                            </Typography>
                            <MuiBox
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 2,
                                marginTop: "10px",
                              }}
                            >
                              <MuiBox sx={{ minWidth: "50%" }}>
                                {popuprow.DesktopContent && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Desktop Content
                                  </Typography>
                                )}
                                <Typography
                                  variant="body2"
                                  sx={{ fontSize: "15px", color: "#666" }}
                                >
                                  {popuprow.DesktopContent}
                                </Typography>
                              </MuiBox>
                              <MuiBox sx={{ minWidth: "50%" }}>
                                {popuprow.MobileContent && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Mobile Content
                                  </Typography>
                                )}
                                <Typography
                                  variant="body2"
                                  sx={{ fontSize: "15px", color: "#666" }}
                                >
                                  {popuprow.MobileContent}
                                </Typography>
                              </MuiBox>
                            </MuiBox>
                          </MuiBox>
                        </TableCell>
                        <TableCell align="left" sx={{ width: "150px" }}>
                          <CustomProgressBar value={popuprow.Proportion} />
                        </TableCell>
                        <TableCell align="left" sx={{ width: "150px" }}>
                          <CustomProgressBar value={popuprow.Appearance} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={3} md={3}>
            <Box>
              <Typography>Assigned Comparison Tables</Typography>
              <TableContainer className="pagegroupwrap">
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">#</TableCell>
                      <TableCell align="left">Table Name</TableCell>
                      <TableCell align="left">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {comparisonTables.map((AssignedComparisonTablerow: any) => (
                      <TableRow
                        key={AssignedComparisonTablerow.number}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="left">
                          {AssignedComparisonTablerow.number}
                        </TableCell>
                        <TableCell align="left">
                          {AssignedComparisonTablerow.tablename}
                        </TableCell>
                        <TableCell align="left">
                          {AssignedComparisonTablerow.status === true ? (
                            <Alert
                              sx={{
                                padding: "2px",
                                width: "auto",
                                fontSize: "13px",
                                height: "25px",
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#EDF7ED",
                                border: "1px solid #2E7D3280",
                                color: "#1E4620",
                              }}
                              icon={
                                <CheckCircleOutlineRoundedIcon
                                  fontSize="small"
                                  sx={{ color: "#1E4620" }}
                                />
                              }
                            >
                              {"Active"}
                            </Alert>
                          ) : (
                            <Alert
                              sx={{
                                padding: "2px",
                                fontSize: "13px",
                                display: "flex",
                                alignItems: "center",
                                height: "25px",
                                backgroundColor: "#E0E0E0",
                                border: "1px solid #9E9E9E",
                                color: "#00000099",
                              }}
                              icon={
                                <CancelOutlinedIcon
                                  fontSize="small"
                                  sx={{ color: "#00000099" }}
                                />
                              }
                            >
                              {"Inactive"}
                            </Alert>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid item xs={3} md={3}>
            <Box>
              <Typography>Assigned Traffic Sources</Typography>
              <TableContainer className="pagegroupwrap">
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">#</TableCell>
                      <TableCell align="left">Source Name</TableCell>
                      <TableCell align="left">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {trafficSources.map(
                      (createAssignedTrafficSourcerow: any) => (
                        <TableRow
                          key={createAssignedTrafficSourcerow.number}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {createAssignedTrafficSourcerow.number}
                          </TableCell>
                          <TableCell align="left">
                            {createAssignedTrafficSourcerow.sourcename}
                          </TableCell>
                          <TableCell align="left">
                            {createAssignedTrafficSourcerow.status === true ? (
                              <Alert
                                severity="success"
                                sx={{
                                  padding: "2px",
                                  width: "auto",
                                  height: "25px",
                                  fontSize: "13px",
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "#EDF7ED",
                                  border: "1px solid #2E7D3280",
                                  color: "#1E4620",
                                }}
                                icon={
                                  <CheckCircleOutlineRoundedIcon
                                    fontSize="small"
                                    sx={{ color: "#1E4620" }}
                                  />
                                }
                              >
                                {"Active"}
                              </Alert>
                            ) : (
                              <Alert
                                sx={{
                                  padding: "2px",
                                  fontSize: "13px",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "25px",
                                  backgroundColor: "#E0E0E0",
                                  border: "1px solid #9E9E9E",
                                  color: "#00000099",
                                }}
                                icon={
                                  <CancelOutlinedIcon
                                    fontSize="small"
                                    sx={{ color: "#00000099" }}
                                  />
                                }
                              >
                                {"Inactive"}
                              </Alert>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid item xs={4} md={4}>
            <Box>
              <Typography>Default Meta Settings</Typography>
              <TableContainer className="pagegroupwrap">
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Device</TableCell>
                      <TableCell align="left">Second Headline</TableCell>
                      <TableCell align="left">Banner Image</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transformedData.map((defaultmetarow, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="left">
                          {defaultmetarow?.device}
                        </TableCell>
                        <TableCell align="left">
                          {defaultmetarow?.secondheadline}
                        </TableCell>
                        <TableCell align="left">
                          <Link
                            to={defaultmetarow?.bannerimage}
                            target="_blank"
                          >
                            {defaultmetarow?.bannerimage.split("/").pop()}
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default AdditionalPageGroupContent;
